import React, { useState } from 'react';
import TermsAndConditionsView from './terms-and-conditions-view.tsx';
import PrivacyPolicyView from './privacy-policy-view.tsx';
import CookiePolicyView from './cookie-policy-view.tsx';
import Co2InformationView from './co2-information-view.tsx';
import EfficiencyInformationView from './efficiency-information-view.tsx';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

export enum Views {
	Home,
	TermsAndConditions,
	PrivacyPolicy,
	CookiePolicy,
	Co2Information,
	EfficiencyInformation
}

interface ImportantInformationViewProps {
	onBackButtonClicked: () => void;
}

interface MainViewProps {
	handleLinkClicked: (viewState:Views) => void;
}

interface InformationLinkProps {
	name: string;
	onClick:() => void;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export function ImportantInformationView(props: ImportantInformationViewProps) {

	// states.

	const [view, setView] = useState(Views.Home);

	// handlers.

	// give the user an option to leave the page back to the vehicle view.
	const handleBackButtonClicked = () => {
		if (view === Views.Home) {
			props.onBackButtonClicked();
		} else {
			setView(Views.Home);
		}
	}

	const handleLinkClicked = (viewState: Views) => {
		setView(viewState);
	}

	// conditionally render views.
	const currentView = () => {
		switch (view) {
			case Views.Home:

				// present the home view.
				return (
					<MainView
						handleLinkClicked={handleLinkClicked}
					/>
				);

			case Views.TermsAndConditions:

				// present the Ts & Cs view.
				return (
					<TermsAndConditionsView />
				);

			case Views.PrivacyPolicy:

				// present the privacy policy view.
				return (
					<PrivacyPolicyView />
				);

			case Views.CookiePolicy:

				// present the cookie policy view.
				return (
					<CookiePolicyView />
				);

			case Views.Co2Information:

				// present the CO2 info view.
				return (
					<Co2InformationView />
				);

			case Views.EfficiencyInformation:

				// present the efficiency info view.
				return (
					<EfficiencyInformationView />
				);

			default:
				return null;
		}
	};


	// return the HTML.
	return (
		<div className="important-information-container">
			{currentView()}
			<div id="footer">
				<button className="summary-button" onClick={handleBackButtonClicked}>
					<img alt="<" src={'assets/images/icons/up-arrow.svg'}/>
					 BACK
				</button>
			</div>
		</div>
	);
}

//-----------------------------------------------------------------------------------------
// Private Components:
//-----------------------------------------------------------------------------------------

function MainView(props: MainViewProps) {

	// navigate views.
	const onClick = (viewState: Views) => {
		props.handleLinkClicked(viewState);
	}

	// return the HTML.
	return (
		<div className="summary-content">
			<div id="view-content-header">
				<h2 id="ga4-important-information">Important Information</h2>
			</div>
			<InformationLink
				name="1. Terms & Conditions"
				onClick={() => onClick(Views.TermsAndConditions)}/>
			<InformationLink
				name="2. Privacy Policy"
				onClick={() => onClick(Views.PrivacyPolicy)}/>
			<InformationLink
				name="3. Cookie Policy"
				onClick={() => onClick(Views.CookiePolicy)}/>
			<InformationLink
				name="4. CO2 Information"
				onClick={() => onClick(Views.Co2Information)}/>
			<InformationLink
				name="5. Efficiency Information"
				onClick={() => onClick(Views.EfficiencyInformation)}/>
		</div>
	);
}

function InformationLink(props:InformationLinkProps) {
	return (
		<a
			role="button"
			className="information-link"
			onClick={props.onClick}
		>{props.name}</a>
	);
}